import styled from 'styled-components'

export const Disabler = styled.div<any>`
  ${props => props.disabled && `
    cursor: wait;
    > * {
      pointer-events: none;
    }
  `}
`
